import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListCountry from "../Components/Country/listCountry.jsx";
import AddCountry from "../Components/Country/addCountry.jsx";
import ViewCountry from "../Components/Country/viewCountry.jsx";
import EditCountry from "../Components/Country/editCountry.jsx";

const CountryRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <Routes>
      <Route path="/country" element={<ListCountry />}></Route>
      <Route path="/country/add" element={canAdd ? <AddCountry /> : <Navigate to="/country" replace />}></Route>
      <Route path="/country/view/:id" element={<ViewCountry />}></Route>
      <Route path="/country/edit/:id" element={canEdit ? <EditCountry /> : <Navigate to="/country" replace />}></Route>
    </Routes>
  );
};

export default CountryRoutes;
